import React from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app";
import { ControllApp } from "./controll-app";
import { WebApp } from "./web-app";

const APP_BASE_HOSTNAME = process.env.APP_BASE_HOSTNAME;

const container = document.getElementById("root");
if (!container) {
  throw new Error("No container found");
}

const root = createRoot(container);

root.render(
  <App>
    {location.hostname === APP_BASE_HOSTNAME ? <ControllApp /> : <WebApp />}
  </App>,
);
